import { ReactElement, memo } from 'react';

import { AddNewButton } from './AddNewButton';
import { CopyButton } from './CopyButton';
import { CustomButton } from './CustomButton';
import { DownloadCsvButton } from './DownloadCsvButton';
import { ReorderButton } from './ReorderButton';
import './styles.css';

export enum HeaderActionTypes {
  ADD_NEW = 'ADD_NEW',
  DOWNLOAD_CSV = 'DOWNLOAD_CSV',
  REORDER = 'REORDER',
  CUSTOM = 'CUSTOM',
  COPY = 'COPY',
}

export type CustomAction = {
  variant: 'text' | 'outlined' | 'contained';
  color: 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';
  Icon: ReactElement;
  label: string;
};

export type HeaderAction = {
  id: number;
  type: HeaderActionTypes;
  custom?: CustomAction;
  label?: string;
  handler(): void;
  disabled?: boolean;
};

interface ListHeaderActionsProps {
  headerActions: HeaderAction[];
}

export const ListHeaderActions = memo(({ headerActions }: ListHeaderActionsProps) => {
  const getAction = (action: HeaderAction) => {
    let Component;

    if (action.type === HeaderActionTypes.ADD_NEW) {
      Component = AddNewButton;
    } else if (action.type === HeaderActionTypes.DOWNLOAD_CSV) {
      Component = DownloadCsvButton;
    } else if (action.type === HeaderActionTypes.COPY) {
      Component = CopyButton;
    } else if (action.type === HeaderActionTypes.CUSTOM) {
      Component = CustomButton;
    } else if (action.type === HeaderActionTypes.REORDER) {
      Component = ReorderButton;
    } else {
      Component = null;
    }

    return Component ? <Component key={action.id} action={action} /> : null;
  };

  return <div className="list-header-actions">{headerActions.map((action: HeaderAction) => getAction(action))}</div>;
});
